import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ExternalClientTypeListItemDto {
  id: number;
  name: string;
  description: string;
  createdAt: string;
}

export interface ExternalClientTypeRequestDto {
  name: string;
  description: string;
}

@Injectable({
  providedIn: 'root',
})
export class ExternalClientTypeService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  list(): Observable<ExternalClientTypeListItemDto[]> {
    const url = `${this.apiUrl}/sicred/api/v1/externalclienttypes`;
    return this.http.get<ExternalClientTypeListItemDto[]>(url, {
      withCredentials: true,
    });
  }

  create(request: ExternalClientTypeRequestDto): Observable<ExternalClientTypeListItemDto> {
    const url = `${this.apiUrl}/sicred/api/v1/externalclienttypes`;
    return this.http.post<ExternalClientTypeListItemDto>(url, request, {
      withCredentials: true,
    });
  }
}
